import { useMutation } from "react-query";
import { checkDuplicateUsername } from "../../api/auth";
import { useNavigate } from "react-router-dom";

export const useCheckDuplicateUsername = () => {
  const navigate = useNavigate();
  const onError = ({
    response: {
      status,
      data: { code },
    },
  }) => {};
  const onSuccess = ({ data: { isDuplicateUsername } }) => {
    if (isDuplicateUsername) {
      alert("이미 존재하는 이메일입니다.");
    } else {
      navigate("/register/password");
    }
  };
  return useMutation(checkDuplicateUsername, {
    onError,
    onSuccess,
  });
};
